import { Nav } from "react-bootstrap";

const MentionsBlock = ({
  mentions,
  title,
  type,
  selectedMention,
  setSelectedMention,
}) => {
  const onMentionClick = (ind) => {
    setSelectedMention(ind)
  }

  return (
    <>
      <h3 className="h6 text-gray-600 text-uppercase mb-4 fw-normal">
        {title}
      </h3>
      <Nav variant="pills" className="mention-pills text-sm mb-3 mb-md-4">
        {mentions.map((item, index) => (
          <Nav.Item key={item.title}>
            <Nav.Link
              className={
                index === selectedMention ? `active ${type}` : ` ${type}`
              }
              onClick={() => onMentionClick(index)}
            >
              {item.title}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </>
  )
}

export default MentionsBlock
